<template>
  <b-link
    :to="`/courses/${course.courseCode}`"
    v-b-tooltip.hover
    :title="openCourse"
    variant="primary"
  >
    <b-card
      :title="course.name"
      :img-src="domainUrl(course.imageUrl)"
      img-alt="Course Image"
      img-top
      tag="article"
      class="course-card"
    >
      <b-card-text class="my-3 text" v-html="course.description" />
      <b-button variant="outline-secondary">
        Purchased on {{ localTime }}
      </b-button>
    </b-card>
  </b-link>
</template>

<script>
import { formatUtcToLocal } from '@/utils/time';
export default {
  name: "PurchasedCourseCard",
  props: {
    course: Object,
    domain: String,
    openCourse: String,
  },
  computed: {
    localTime() {
      const utcTime = this.course?.memberCourse?.createTime;
      return formatUtcToLocal(utcTime); // 默认格式 'YYYY/MM/DD HH:mm'
    }
  },
  methods: {
    domainUrl(path) {
      return `${this.domain}${path}`;
    }
  }
};
</script>

<style scoped>
.course-card {
  max-width: 30rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.text {
  /*width: 500px;*/
  /*overflow: hidden;*/
  /*white-space: nowrap;*/
  /*text-overflow: ellipsis;*/
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /*word-break: break-all;*/  /*注意这个文字多行很重要*/
  -webkit-box-orient: vertical;
}
</style>
